import { Fade } from '@progress/kendo-react-animation'
import { NotificationGroup as NotificationGroupBase } from '@progress/kendo-react-notification'
import { useAtomValue } from 'jotai'
import React from 'react'

import { notificationsAtom } from '~/atoms'

import { Notification } from './components/Notification'
import styles from './NotificationGroup.css'

export type NotificationGroupProps = {
  'data-testid'?: string
}

export const NotificationGroup = ({
  'data-testid': dataTestId = 'components-elements-notification-group',
}: NotificationGroupProps) => {
  const notifications = useAtomValue(notificationsAtom)

  return (
    <NotificationGroupBase className={styles.root} data-testid={dataTestId}>
      <Fade enter={true} exit={true}>
        {notifications.map(({ content, style, timestamp }) => (
          <Notification
            key={timestamp}
            content={content}
            style={style}
            timestamp={timestamp}
          />
        ))}
      </Fade>
    </NotificationGroupBase>
  )
}
